import { createTheme } from '@mui/material/styles';

import { breakpoints } from './breakpoints';
import { typography } from './typography';

export const darkTheme = createTheme({
  breakpoints,
  typography: {
    ...typography,
    allVariants: {
      color: 'var(--color-fg-primary)',
    },
    body16: {
      ...typography.body16,
      color: 'var(--color-fg-tetriary)',
    },
    body14: {
      ...typography.body14,
      color: 'var(--color-fg-tetriary)',
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body16: 'p',
          body14: 'p',
        },
      },
    },
  },
  palette: {
    mode: 'dark',
    background: {
      default: 'var(--color-global-primary)',
      card: 'var(--color-global-card)',
    },
    color: {
      fg: {
        primary: 'var(--color-fg-primary)',
        inversePrimary: 'var(--color-fg-inverse-primary)',
        foregroundFgPrimary: 'var(--foreground-fg-primary)',
        tetriary: 'var(--color-fg-tetriary)',
        unactive: 'var(--color-fg-unactive)',
      },
      global: {
        primary: 'var(--color-global-primary)',
        card: 'var(--color-global-card)',
      },
      surface: {
        modalTetriary: 'var(--color-surface-transparent-modal-tetriary)',
        modalTetriaryHover:
          'var(--color-surface-transparent-modal-tetriary-hover)',
      },
      grey: {
        light20: 'var(--color-grey-light-20)',
        light8: 'var(--color-grey-light-8)',
        dark16: 'var(--color-grey-dark-16)',
        dark8: 'var(--color-grey-dark-8)',
      },
      button: {
        primaryDefault: 'var(--color-button-primary-default)',
        primaryHover: 'var(--color-button-primary-hover)',
        secondaryDefault: 'var(--color-button-secondary-default)',
        secondaryHover: 'var(--color-button-secondary-hover)',
        floatingDefault: 'var(--color-button-floating-default)',
      },
      divider: 'var(--color-divider)',
      stroke: {
        dividerTransparent: 'var(--color-stroke-divider-transparent)',
      },
      avatar: 'var(--color-avatar)',
      yellow: 'var(--color-yellow)',
      orange: 'var(--color-orange)',
      green: 'var(--color-green)',
      lightGreen: 'var(--color-light-green)',
    },
  },
});
